
import { setRefundApproval, setRefundBatchApproval } from '@/api/approval/refund';

const refundMixins = {
  data() {
    return {
      refundObj: {}, // 退款审核对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/驳回弹窗
      submitLoading: false,
    };
  },
  methods: {
    /**
     * 退款审核 确认/驳回
     * refundNo     退款审核编号
     * operation     操作：1、确认 2、驳回
     * cancelRemark  驳回原因，驳回时传入
    */
    handleOperateState(operation, row) {
      this.refundObj = {
        refundNo: row?.refundNo || '',
        operation,
        cancelRemark: '',
      };
      const list = {
        1: {
          title: '审核通过确认',
          messageTip: '是否通过该笔退款申请？',
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '驳回原因',
          isPass: false,
          required: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 退款审核列表-退款批量审核操作+退款审核操作请求接口
    async setRefundApproval(params) {
      try {
        this.submitLoading = true;
        if (this.textConfig?.isBatch) { // 批量
          await setRefundBatchApproval(params);
        } else {
          await setRefundApproval(params);
        }
        this.$message({
          message: '操作成功！',
          type: 'success',
        });
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.handleOperateStateResults();
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
  },
};

export default refundMixins;
